export function loginState() {
    const nav = document.querySelector<HTMLElement>('nav.utility[data-login-api-base]');
    if (!nav) return;

    const loggedOut = document.querySelector<HTMLElement>('[data-login-state="logged-out"]');
    const loggedIn = document.querySelector<HTMLElement>('[data-login-state="logged-in"]');

    const applyState = (isLoggedIn: boolean) => {
        if (loggedOut) loggedOut.hidden = isLoggedIn;
        if (loggedIn) loggedIn.hidden = !isLoggedIn;
    };

    const base = nav.getAttribute('data-login-api-base') || '';

    // On TNEW pages (base is populated), read login state from TNEW's own DOM
    // instead of cross-origin fetching the Umbraco API. Browsers with third-party
    // cookie blocking (Chrome Tracking Protection, Safari ITP, Firefox TCP) strip
    // the session cookie from the cross-site fetch even with SameSite=None, so the
    // API returns anonymous for logged-in users. TNEW server-renders the BEM
    // modifier class `--logged-in` on its account panel; fall back to the presence
    // of a logout link in case TNEW's markup changes.
    if (base) {
        const tnewLoggedIn =
            !!document.querySelector('.tn-utility-nav-account-section--logged-in') ||
            !!document.querySelector('a[href*="/account/logout"]');
        applyState(tnewLoggedIn);
        return;
    }

    fetch(`${base}/umbraco/api/loginstate/isloggedin`, {
        credentials: 'include',
        headers: { 'Accept': 'application/json' }
    })
        .then(response => response.ok ? response.json() : false)
        .then((isLoggedIn: boolean) => applyState(isLoggedIn))
        .catch(() => {
            if (loggedOut) loggedOut.hidden = false;
        });
}
